import { useSelector } from "react-redux";

import Th from "@/components/Table/Th";
import { table_head } from "../orders_return_constants";
import { textConstants } from "@/languages/textConstants";

const OrdersReturnTableHead = ({ base, setBase }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const setAllOrder = (order, orderType) => {
		setBase({ ...base, order: order, orderType: orderType });
	};

	const newHead = table_head.map((item) => {
		if (item.name === "delivery_text_numero") {
			item.name = textConstants[customer.country_id].delivery;
		}

		return item;
	});

	return (
		<thead>
			<tr>
				{newHead &&
					newHead.map((item, i) => {
						return (
							<Th
								key={i}
								item_name={item.name}
								item_size={item.size}
								item_order={item.order}
								order={base.order}
								setOrder={null}
								orderType={base.orderType}
								setOrderType={null}
								item_class={item.class}
								item_check_permission={item.check_permission}
								setAllOrder={setAllOrder}
							/>
						);
					})}
			</tr>
		</thead>
	);
};

export default OrdersReturnTableHead;
